const angular = require('angular');

angular.module('wowApp.shop')
    .service('TrolleyService', ['$rootScope', 'Restangular', '$q', 'GtmService', 'BootstrapService', 'LoginService', 'ShopperService', 'SettingsService',
        'DeliveryPassService', 'InspirationService', 'TrolleySource', 'BreakpointsService', 'RichRelevanceService', 'FeatureService', 'AnalyticsService', require('./trolley.service')])
    .constant('TrolleySource', require('./trolley-source'));



// WEBPACK FOOTER //
// ./src/shop/trolley/index.js